import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

class ManagedCheckbox extends React.Component {
  static propTypes = {
    checked: PropTypes.bool,
    children: PropTypes.any,
    className: PropTypes.string,
    flex: PropTypes.bool,
    indeterminate: PropTypes.bool,
    inputOnly: PropTypes.bool,
    label: PropTypes.string,
    labelClassName: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.bool,
    wrapperClassName: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onValueChange: PropTypes.func.isRequired
  }

  checkRef = React.createRef();

  componentDidMount() {
    if (this.checkRef.current) {
      this.checkRef.current.indeterminate = this.props.indeterminate;
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.indeterminate !== prevProps.indeterminate) {
      this.checkRef.current.indeterminate = this.props.indeterminate;
    }
  }

  handleChange = (event) => {
    const { checked } = event.target;
    this.props.onChange({ [this.props.name]: checked }, event);
    this.props.onValueChange(checked, event);
  }

  render() {
    const {
      checked,
      children,
      className,
      indeterminate,
      label,
      labelClassName = 'd-flex align-items-center gap-2',
      value,
      wrapperClassName,
      onChange,
      onValueChange,
      ...props
    } = this.props;

    let checkbox = (
      <input
        {...props}
        checked={checked || value || false}
        className={classNames('form-check-input', className)}
        ref={this.checkRef}
        type="checkbox"
        onChange={this.handleChange}
      />
    );

    if (!this.props.inputOnly) {
      checkbox = (
        <div className={classNames(wrapperClassName)}>
          <label className={classNames(labelClassName)}>
            {checkbox}
            {children || label}
          </label>
        </div>
      );
    }

    return checkbox;
  }
}

export default ManagedCheckbox;
